<template>
  <div style="margin-top: 20px">
    <div class="goods_msg">
      <div class="goods_list">
        <div class="goods_l">物流名称</div>
        {{ allBox.logisticsName }}
      </div>
      <div class="goods_list">
        <div class="goods_l">发货仓库</div>
        {{ allBox.orgName }}
      </div>
      <div class="goods_list">
        <div class="goods_l">订单数量</div>
        {{ allBox.orderCount }}
      </div>
      <div class="goods_list">
        <div class="goods_l">箱数</div>
        {{ allBox.invoicePackageSize }}
      </div>
    </div>
    <div class="box_wrap">
      <div class="wrap_list" v-for="(item, index) in allBox.packageInfoList" :key="index">
        <div class="box_num">
          第{{ item.packageSize }}箱（共计{{ allBox.invoicePackageSize }}箱）
          <div v-show="item.shipmentStatus==2" class="status_icon">{{item.shipmentStatus==2?'本箱不发做售后':''}}</div>
        </div>
        <div class="product_box" v-for="(ele, eleIndex) in item.packageSubInfoDtoList">
          <img class="product_img" :src="ele.modelThumbnailImg" alt="" />
          <div class="product_msg">
            <div class="product_name">产品名称：{{ ele.productName }}</div>
            <div class="model_name">型号名称：{{ ele.modelName }}</div>
            <div class="model_num">数量：{{ ele.modelCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      // initData: {
      //   type: Object,
      //   // default: function () { return [] }
      //   default: () => {},
      // },
      allBox: {
        type: Object,
        // default: function () { return [] }
        default: () => { },
      },
    },
    data() {
      return {};
    },
    created() { },
    methods: {},
  };
</script>

<style scopen>
  .goods_msg {
    width: 94%;
    margin: 0 auto;
  }

  .goods_list {
    font-size: 16px;
    text-align: left;
  }

  .goods_l {
    display: inline-block;
    width: 100px;
    color: #999999;
    margin-bottom: 18px;
    /* text-align: left; */
    /* margin-right: 20px; */
  }

  .product_box {
    background-color: #fff;
    /* clear: both; */
    overflow: hidden;
    padding: 10px 3%;
    /* display: flex;
  justify-content: space-between; */
  }

  .box_num {
    /* text-align: center; */
    padding-left: 3%;
    height: 40px;
    line-height: 40px;
    background-color: #f5f6f8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .status_icon {

    height: 20px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    padding: 2px 8px;
    background-color: #ff4d4f;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
  }

  .product_img {
    width: 120px;
    height: 120px;
    float: left;
    margin-right: 12px;
    /* border: 1px solid #ccc; */
  }

  .product_msg {
    width: 60%;
    color: #333333;
    float: left;
    font-size: 16px;
    margin-top: 10px;
    text-align: left;
  }

  .product_name,
  .model_name,
  .model_num {
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/allGoodsInfo.vue